import axios from 'axios';
import { getApiEnvironment } from '@innovyze/stylovyze/lib/utils/getApiEnvironment';
import { getService } from '@innovyze/stylovyze/lib/utils/getService';
import { getBearerAuth0Token } from '@innovyze/stylovyze/lib/utils/authUtils';
import config from './config.api';
export const exportBaseURL = getService('export', config, getApiEnvironment());
const options = {
    baseURL: exportBaseURL,
    timeout: 15000,
};
const auth = axios.create(options);
auth.interceptors.request.use(conf => {
    conf.headers.Authorization = getBearerAuth0Token();
    return conf;
}, error => {
    Promise.reject(error);
});
export default auth;
